export enum RECOVERY_REASON {
  PENDING = 'pending',
  PAST_DUE = 'past-due',
  UNPAID = 'unpaid',
  NO_PAYMENT_METHOD = 'no-payment-method',
  CARD_EXPIRED = 'card-expired',
  CARD_EXPIRING_SOON = 'card-expiring-soon',
}
